import { useContext } from "react";
import Page from "src/components/Report/Page";
import { logoPath } from "src/config";
import jobContext from "src/context/jobContext";
import { getJalaliSeasonYear } from "src/utils/getJalaliSeasonYear";

export default function Page100() {
    const { job } = useContext(jobContext)
    return (
        <Page isInnerPage={false}>
            <div className="flex flex-col gap-20 h-full items-center justify-center">
                <div className="flex gap-[3px] h-[400px]">
                    <div className="h-full w-[3px] bg-gray-700"></div>
                    <div className="h-full w-[3px] bg-orange-900"></div>
                    <div className="h-full w-[3px] bg-blue-900"></div>
                    <div className="h-full w-[3px] bg-green-900"></div>
                    <div className="h-full w-[3px] bg-gray-700"></div>
                    <div className="h-full w-[3px] bg-orange-900"></div>
                    <div className="h-full w-[3px] bg-blue-900"></div>
                    <div className="h-full w-[3px] bg-green-900"></div>
                    <div className="h-full w-[3px] bg-gray-700"></div>
                    <div className="h-full w-[3px] bg-orange-900"></div>
                    <div className="h-full w-[3px] bg-blue-900"></div>
                    <div className="h-full w-[3px] bg-green-900"></div>
                </div>
                <div className="w-[300px] text-justify">
                    اگر روزی بخواهیم در عرصه پرتلاطم كسب و كار
                    های امروزی، پا در میدان رقابت سنگین بگذاریم،
                    چاره ای جز در این نخواهیم یافت كه شایسته ترین
                    ها استخدام كنیم، شایستگی ها را بهبود بخشیم و
                    شایسته ها را در محور تصمیم گیری قرار دهیم.
                    در این هنگام خواهد بود كه نتایج این گزارش بیش
                    از پیش به درد مدیران خواهد خورد!
                </div>
                <div className="flex flex-col justify-center gap-4 items-center">
                    <img src={job.organization ? process.env.REACT_APP_API_URL + "/img/" + job.organization.logo : logoPath} className="w-[120px]" />
                    <span className="font-bold">{job.orgUnit}</span>
                    <span className="font-bold text-lg">{getJalaliSeasonYear()}</span>
                </div>
            </div>
        </Page>
    )
}